import moment from 'moment'

export const commonColors = {
  ctaPrimary: '#3861FB',
  ctaSecondary: '#008D80',
  data0: 'rgb(105, 161, 243)',
  data1: '#eeff00ff', // turquoise
  data2: '#ffa15a', // orange
  data3: '#b978ff', // purple
  data4: '#1E75FF', //blue
  data5: '#EAAA08', // yellow
  data6: '#00875A', //dark green
  data7: '#5243AA', //purple
  data8: '#FF991F', //yellow
  data9: '#E31B54', // red
  data10: '#F670C7', // pink
  data11: '#D0D5DD', // white
  starColor: '#F5B882',
  warning: '#F79009',
  // graphColor1: '#0062FF', // blue
  graphColor1: '#ECEC8F',
  // graphColor2: '#50B5FF', // ligth blue
  graphColor2: '#ECEC8F', // ligth yellow
  calendar: '#5651F3',
  stockUp: '#2BD784',
  stockDown: '#FF5858',
  activeButton: '#5F81CC',
  /* New colors:
  data1: '#FF8331', // orange
  data2: '#0047FF', // blue
  data3: '#FF086E', // purple
  data4: '#04D1AA', // turquoise
  */
}

export const themeTypography = {
  body: {
    fontWeight: '300',
    fontSize: '14px',
    lineHeight: '22px',
  },
  micro: {
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '18px',
  },
  h1: {
    fontWeight: '300',
    fontSize: '36px',
    lineHeight: '48px',
  },
  h2: {
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '32px',
  },
  h3: {
    fontWeight: '300',
    fontSize: '18px',
    lineHeight: '28px',
  },
  h4: {
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '24px',
  },
  h6: {
    fontSize: '10px',
    fontWeight: '300',
    lineHeight: '18px',
  },
}

export const themeFeatures = {
  borderRadius: '4px',
}

export const themeSize = {
  small: '38px',
}

export const compatitionGraphLineColors = [ commonColors.data11, commonColors.data10, commonColors.data9 ]

export const mainGraphLineColors = [ commonColors.data1, commonColors.data2, commonColors.data3, commonColors.data4 ]

export const discoveryColors = [ commonColors.data5, commonColors.data6, commonColors.data7, commonColors.data8 ]

// export const barGroupColors = [ commonColors.graphColor1, commonColors.graphColor2]
export const barGroupColors = [ commonColors.graphColor1, commonColors.graphColor2]

export const mainGraphColorNames = ['data1', 'data2', 'data3', 'data4']

export const graphOptions = [
    {name:'Absolute',value:'NONE'},
    {name:'Absolute Change',value:'ABSOLUTE_CHANGE'},
    {name:'Change (%)',value:'PRC_CHANGE'},
    {name:'Relative Change',value:'RC'},
    {name:'YoY Change (%)',value:'YOY'},
    {name:'Yo2Y Change (%)',value:'2YOY'},
    {name:'Yo3Y Change (%)',value:'3YOY'},
    {name:'Smoothing-21 Days',value:'S21'},
    {name:'Smoothing-42 Days',value:'S42'},
    {name:'Smoothing-63 Days',value:'S63'},
    {name:'Lead-1',value:'LEAD-1'},
    {name:'Lag-1',value:'LAG-1'}
  ]

export const normalizationGraphOptions = [
    {name:'NONE',value:'NONE'},
    {name:'Normalized - Min <> Max',value:'normalize'},
    {name:'Z-Score',value:'zscore'}]

export const timeRangeGraphOptions = [
    {name:'3 Years',value:'3YEARS'},
    {name:'2 Years',value:'2YEARS'},
    {name:'1 Year',value:'1YEAR'},
    {name:'6 Months',value:'6MONTHS'},
    {name:'3 Months',value:'3MONTHS'},
    {name:'1 Months',value:'1MONTHS'},
    {name:'1 Week',value:'1WEEK'},
    {name:'All Time',value:'ALL'}]
      
export const dayInMs = 86400000
export const graphYearAgo = moment().subtract(1,'y')
